import { useState, useEffect } from "react";
import { EditorSection, AuthBtn, CenterContainer } from "./EditorTemplate";



const LoginScreen = ({ handleLogin, errorText }) => {

    const [username, setUsername] = useState('tootles');
    const [password, setPassword] = useState('smellmyfarts69');
    
    return (
        <EditorSection>
            <div style={{ padding: '20px', maxWidth: '400px', margin: '50px auto', border: '1px solid #ccc', borderRadius: '8px' }}>
                <h3 className="editor">Login</h3>
                <div>
                    <div>
                        <label htmlFor="username">Username:</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                        />
                    </div>
                    <div>
                        <label htmlFor="password">Password:</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                        />
                    </div>
                    {errorText && <CenterContainer>
                            <p className="center-text" style={{color:"red"}}>{errorText}</p>
                        </CenterContainer> 
                    }
                    <CenterContainer>
                        <AuthBtn auth_action={()=>handleLogin(username, password)} text={"Log In"} /> 
                    </CenterContainer>
                </div>
            </div> 
        </EditorSection>
    ) 
}


export default LoginScreen;